import { render, staticRenderFns } from "./DoctorSet.vue?vue&type=template&id=0cc25b32&scoped=true&"
import script from "./DoctorSet.vue?vue&type=script&lang=js&"
export * from "./DoctorSet.vue?vue&type=script&lang=js&"
import style1 from "./DoctorSet.vue?vue&type=style&index=1&id=0cc25b32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc25b32",
  null
  
)

export default component.exports